(function($,w){$(function(){"use strict";

    /* ----------------------------- Console Brand --------------------------------- */

    let brand =
`
 .\\\\            //.
. \\ \\          / /.
.\\  ,\\     /\` /,.-
 -.   \\  /'/ /  .
 \` -   \`-'  \\  -
   '.       /.\`
      -    .-
      :\`//.'
      .\`.'  BRUNO BOUYAJDAD - bouyajdad.com
      .'    AI implementation, Web development
`;

    console.log( "%c" + brand, "font-size: 16px; color: #ccc;" );

    /* ----------------------------- Cookie Link --------------------------------- */

    // var privacy = $( 'p.borlabsCookieSubHeadline' ).parent().find( 'a' ).prop( 'target', '_blank' ).first();

    // privacy.prop( 'href', privacy.prop( 'href' ) + '#privacy' ).text( 'Privacy Policy' );

    /* ----------------------------- Sticky Nav --------------------------------- */

        var header = $( '#main-header' ).addClass( 'normal' );

        if ( header.length )
        {

            let sticky   = false,
                winWidth = $( w ).width(),
                main     = $('div#et-main-area'),
                body     = $('body').addClass('sticky-nav'),
                inner    = header.find('#et-top-navigation'),
                padding  = inner.css('padding-top'),
                height   = inner.css('height'),
                navTop   = header.offset().top,
                navBar   = function( $this )
                {

                    let top = $this.scrollTop();

                    if ( top > navTop + 250 && ! sticky )
                    {

                        header.css( 'top', 0 );
                        body.addClass( 'sticky' );

                        if ( header.hasClass( 'normal' ) )
                        {
                            setTimeout( function()
                            {

                                header
                                    .addClass( 'sticky' )
                                    .removeClass( 'normal' )
                                    .find( '#et-top-navigation' )
                                    .css({ 'padding-top': 23, 'height': 60 });

                            }, 200 );

                        }

                        sticky = true;

                    }

                    else if ( 0 === top )
                    {

                        body.removeClass( 'sticky' );
                        header.addClass( 'normal' ).removeClass( 'sticky' );

                        header
                            .animate({ 'top': 0 }, 300 )
                            .find( '#et-top-navigation' )
                            .animate({ 'padding-top': padding, 'height': height }, 10, function() { sticky = false; });

                    }
                }

            $( w ).resize( function()
            {
                winWidth = $( this ).width();

                if ( winWidth < 981 )
                {
                    if( body.hasClass( 'sticky' ))
                        body.removeClass('sticky');

                    if( header.hasClass( 'sticky' ))
                        header.addClass('normal').removeClass('sticky');

                    sticky = false;
                }

                else
                {
                    navBar( $( this ) );
                }
            });

            $( w ).scroll( function()
            {
                if ( winWidth > 980 )
                {
                    navBar( $( this ) );
                }
            });
        }

    /* ----------------------------- Animate Element --------------------------------- */

        $( 'a.id-animate' ).on( 'click', function( e )
        {

            e.preventDefault();

            e.stopPropagation();

            let t = $(this),
                sel  = t.data( 'sel' ),
                wid = ( $( w ).width() < 981 ? 30 : 115 ) + ( t.data( 'off' ) ) - ( $( '#main-header' ).hasClass( 'et-fixed-header' ) ? 30 : 0 );

            let elem = $( sel ),
                time = t.data( 'time' );

            if ( elem.length < 1 )
                return false;

            if ( t.hasClass( 'video-start' ) )
                setTimeout( () => { $( sel ).find( '.vjs-tech' ).get( 0 )?.play(); }, time );

            $( 'html, body' ).animate({ scrollTop: elem.offset().top - wid }, time, 'swing', function()
            {

                return;

            });

        });

    /* ----------------------------- Remove Preloader ------------------------- */

        if ( $( '.et-bfb' ).length <= 0 && $( '.et-fb' ).length <= 0  )
        {

            $("#id-status").fadeOut();

            $("#id-preloader").delay(250).fadeOut(250);

        }

        else
        {

            $("#id-preloader").css('display','none');

        }

    // /* ----------------------------- Same height Blurbs -------------------------- */

    $( '.same-height-blurbs' ).each(function()
    {

        let desc = $(this).find( 'div.et_pb_blurb_description,div.et_pb_testimonial_description_inner' ),
            hght = Math.max.apply(null, desc.map(function ()
            {

                return $(this).innerHeight();

            }).get());

        desc.css( 'height', hght );

    });

    /* ----------------------------- TOC -------------------------- */

    $( '.toc-header' ).wrap( '<div class="toc wrap" />' )
        .after( '<span class="toc-item toc-icon header" aria-hidden="true" data-icon="6" data-sel="toc" />' )

    $( '#toc-ol li, div.toc.wrap' ).on( 'click', function( e )
    {

        e.preventDefault()
        e.stopPropagation()

        let delta = 15,
            t = $( this ),
            wid = ( $( w ).width() < 981 ? 0 : 90 ) + delta,
            elem, index

        if ( t.hasClass( 'wrap' ) )
            elem = $( '#toc' )

        else
        {

            index = $( '#toc-ol li' ).index( t )
            elem  = $( '.toc-header' ).eq( index )

        }

        if ( elem.length < 1 )
            return false;

        $( 'html, body' ).animate({ scrollTop: elem.offset().top - wid }, 200, 'swing', function() { return })

    });

    // /* ----------------------------- NAV -------------------------- */

    if ( $( 'body' ).hasClass( 'single-post' ) )
    {

        $( 'span.mobile_menu_bar' ).on( 'click', function( e )
            {

                let $this  = $( this ),
                    parent = $this.closest( 'div.mobile_nav' );

                if ( parent.hasClass( 'closed' ) )
                    parent.removeClass( 'closed' ).addClass( 'opened' );

                else
                    parent.removeClass( 'opened' ).addClass( 'closed' );

            });

            $( '#mobile_menu1' ).remove();

    }

    // /* ----------------------------- Lazy Section Backgrounds -------------------------- */

    let bgLazy = $( 'div.et_pb_section.wwl-bg-lazy[data-wwl-bg]' )

    if ( bgLazy.length )
    {

        let config = w.wwlSectionBgLazy || {},
            offset = 50,
            loadBg = function( elem )
            {

                if ( ! elem || ! elem.length || '1' === elem.attr( 'data-wwl-bg-loaded' ) )
                    return;

                let url      = elem.attr( 'data-wwl-bg' ),
                    gradient = elem.attr( 'data-wwl-bg-gradient' ),
                    overlay  = elem.attr( 'data-wwl-bg-overlay' ),
                    size     = elem.attr( 'data-wwl-bg-size' ),
                    position = elem.attr( 'data-wwl-bg-position' ),
                    repeat   = elem.attr( 'data-wwl-bg-repeat' ),
                    imageCss = '',
                    style    = null

                if ( ! url || '' === url.trim() )
                    return;

                imageCss = 'url("' + url.replace( /"/g, '\\"' ) + '")'
                style    = elem.get(0).style

                if ( gradient && '' !== gradient.trim() )
                    imageCss = 'on' === overlay ? gradient + ', ' + imageCss : imageCss + ', ' + gradient

                style.setProperty( 'background-image', imageCss, 'important' )

                if ( size && '' !== size.trim() )
                    style.setProperty( 'background-size', size, 'important' )

                if ( position && '' !== position.trim() )
                    style.setProperty( 'background-position', position, 'important' )

                if ( repeat && '' !== repeat.trim() )
                    style.setProperty( 'background-repeat', repeat, 'important' )

                elem.attr( 'data-wwl-bg-loaded', '1' )

            }

        if ( ! isNaN( parseInt( config.offset, 10 ) ) )
            offset = Math.max( 0, parseInt( config.offset, 10 ) )

        if ( 'function' != typeof w.IntersectionObserver )
            bgLazy.each( function() { loadBg( $( this ) ) } )

        else
        {

            let observer = new IntersectionObserver( function( entries )
            {

                entries.forEach( function( entry )
                {

                    if ( ! entry.isIntersecting )
                        return;

                    loadBg( $( entry.target ) )
                    observer.unobserve( entry.target )

                })

            }, { rootMargin: offset + 'px 0px ' + offset + 'px 0px' } )

            bgLazy.each( function() { observer.observe( this ) } )

        }

    }

    // /* ----------------------------- Pay Success FluentForms -------------------------- */

    if ( $( 'body' ).hasClass( 'ff_frameless_page_body' ) && $( 'body' ).hasClass( 'ff_frameless_status_success' ) )
    {

        $( 'div.ff_frameless_body' ).prepend( '<img class="logo" src="wp-content/uploads/2025/07/logo-weltweitleben-720.webp">' );

        let counter = $( 'div.ff_frameless_body' ).append( '<p id="counter" class="counter">10</p>' );

        setInterval( () => {
            counter.find( '#counter' ).text( ( parseInt( counter.find( '#counter' ).text() ) - 1 ) )
        }, 1000 );

        // // Forward to profile page
        setTimeout( () => { w.location.href = w.location.origin + '/profil/'; }, 10000 );

    }

    // /* ----------------------------- Add Email to pages -------------------------- */

    const mail = 'k'+'o'+'n'+'t'+'a'+'k'+'t'+'@'+'w'+'e'+'l'+'t'+'w'+'e'+'i'+'t'+'l'+'e'+'b'+'e'+'n'+'.'+'c'+'o'+'m';
    $( 'a.to-fill-1' ).attr( 'href', 'mailto:' + mail ).text( mail );

});}(jQuery,window));
